import Vue from 'vue'
import App from './App.vue'
// 总路由
import router from './router'
// 现金开票路由
// import router from './router/index.rabbit'
import store from './store'
import { sinopecapp_loadNative } from '@/utils/sinopecapp'

import 'normalize.css/normalize.css'

import Vant, { Lazyload } from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
Vue.use(Lazyload)

Vue.config.productionTip = false
Vue.prototype.$sinopecapp_loadNative = sinopecapp_loadNative

var query = window.location.search.substring(1)
var cache = sessionStorage.getItem('token')
var reset = '0'
if (query && query.length > 6) {
  const prefix = query.substring(0, 6)
  if (prefix == 'token=' && query != cache) {
    sessionStorage.setItem('token', query)
    reset = '1'
  }
}
sessionStorage.setItem('reset', reset)
//console.log(query)
//store.dispatch('user/setToken', query)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
